import { useParamsSearch } from '@anytag/shared-hooks';
import { AnalyticsTrendingYoutubePostsSearchSchemaType } from '../schemaTypes';

export const useAnalyticsTrendingYoutubePostsFilter = () =>
  useParamsSearch<AnalyticsTrendingYoutubePostsSearchSchemaType>();
